"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigData = getConfigData;
exports.getConfigValue = getConfigValue;
var _syncRequest = _interopRequireDefault(require("../utils/syncRequest"));
var _utils = require("../utils/utils");
function buildFacetsAPIEndPoint(domainURL) {
  // TODO: this array should come from a sort of config or blob to avoid rebuild everytime.
  if (!domainURL) return;
  const replaceList = ['web-instore', 'web'];
  let apiURL = domainURL;
  for (const r of replaceList) {
    if (domainURL.indexOf(r) > -1) {
      apiURL = apiURL.replace(r, 'api');
      break;
    }
  }
  return apiURL;
}
function getConfigData() {
  const domainURL = !(0, _utils.isNodeServer)() ? window.location.hostname : process.env.NEXT_PUBLIC_DOMAIN;
  const apiURL = buildFacetsAPIEndPoint(domainURL);
  let data = {};
  if (apiURL) {
    data = (0, _syncRequest.default)({
      url: `https://${apiURL}/facet/get-configurations`
    });
    if ((0, _utils.isNodeServer)()) {
      // eslint-disable-next-line no-console
      console.log('[' + new Date().toUTCString().substring(11, 23) + '] -', '🚀 ~ file: configHelper.js:23 ~ getConfigData ~ configData:', data);
    }
  }
  return {
    data
  };
}
function getConfigValue(data, key) {
  const result = data === null || data === void 0 ? void 0 : data[key];
  if (!result) console.warn(`Warning: ~ file: Web.js:6 ~ getConfigValue ~ key - ${key} not found in Facets config`);
  return result;
}